/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import { Util } from "@common/util";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { PopUpService } from "@common/popup/popup.service";
import { IFeedService } from "@common/service/feed.service";
import { IUtilityService } from "@common/service/util.service";
import { PermissionsEnum, Subject, TargetEnum } from "@common/model/subject";
import { IDocumentService } from "@common/service/document.service";
import { TeamPermissionService } from "@common/service/teamPermission.service";
import _ from "lodash";
import { CacheService } from "@common/service/cache.service";
import { BroadcastService } from "@common/service/broadcast.service";
import { IAppRootScopeService } from "@/app/app.definition";
import { PushNotificationService } from "@common/service/push-notification.service";
import { SubjectService } from "@common/service/subject.service";
import { PermissionService } from "ecv/common/permissions";
import { MODULES } from "@common/model/constants";
import { IConditionalModuleLoadService } from '@common/service/conditionalModuleLoad.service';

export class EcvChoice {
    action: string;
    icon: string;
    func: Function;
    text: string;
    confirmation?: string;

    constructor(
        action: string,
        icon: string,
        func: Function,
        text: string,
        confirmation?: string
    ) {
        if (!action || !func) {
            console.error("EcvChoice: Missing name or click function");
        }

        this.action = action;
        this.func = func;
        !!icon && (this.icon = icon);
        !!text && (this.text = text);
        !!confirmation && (this.confirmation = confirmation);
    }

    clickMe: Function = ($event, category, itemId, signCopyExists): void => {
        $event.preventDefault();
        //$event.stopPropagation();

        this.func(category, itemId, signCopyExists);
    };
}

export class EcvChooseMeChoiceList {
    choices: Array<EcvChoice>;
    chooseMe: IEcvChooseMe;
    shouldReload: boolean;

    constructor(chooseMe: IEcvChooseMe) {
        if (!chooseMe) {
            console.log("EcvChooseMeChoiceList: missing chooseMe");
        }

        !!chooseMe && (this.chooseMe = chooseMe);
    }
}

class SubjectChoices extends EcvChooseMeChoiceList {
    constructor(chooseMe: IEcvChooseMe) {
        super(chooseMe);
    }

    getSubjType = (subject: Subject) => {
        let subjType = "the " + subject.projectName + " project";
        if (subject.subjectTypeId == "INDIVIDUAL") {
            subjType = subject.fullName + "'s";
        }
        return subjType;
    };

    editMe: Function = () => {
        if (
            !this.chooseMe.subject.isFrozen &&
            !!this.chooseMe.choiceBroadcast
        ) {
            this.chooseMe.choiceBroadcast("edit");
        }
    };

    deleteMe: Function = () => {
        let subjType = this.getSubjType(this.chooseMe.subject);
        if (this.chooseMe.subject.subjectTypeId == "INDIVIDUAL") {
            subjType = this.chooseMe.subject.fullName + "'s";
        }
        let sent1 = Util.DELETE_TEAM.replace("$subject", subjType);
        this.chooseMe.flag = false;
        this.chooseMe.root.mainShowLoader = "Deleting ..";
        this.chooseMe.api.deleteSubject(this.chooseMe.itemId).then(
            () => {
                this.chooseMe.root.mainShowLoader = false;
                let removeTeam = (teams: Subject[]) => {
                    let indexOfSubject = teams.findIndex(
                        (sub) => sub.subjectId == this.chooseMe.itemId
                    );
                    teams.splice(indexOfSubject, 1);
                };
                removeTeam(this.chooseMe.CacheService.getSortedSubjects());
                removeTeam(this.chooseMe.CacheService.getSubjects());
                if (!!this.chooseMe.choiceBroadcast) {
                    this.chooseMe.choiceBroadcast("delete");
                }
                let infoMsg = "You have successfully deleted this Team.";
                toastr.success(infoMsg, "");
            },
            (e: any) => {
                this.chooseMe.pop.openInformationModal(e);
            }
        );
    };

    addCR: Function = () => {
        this.chooseMe.pop
            .openAssociateTeamProjectPopup(this.chooseMe.subject)
            .then(
                (s) => {
                    this.chooseMe.subject.associatedSubjects = s.subjects;
                    this.chooseMe.updateSubjectCache(s.subjects);
                    this.chooseMe.BroadcastService.broadcast("add-new-team");
                },
                (e) => {
                    if (!!e && !!e.crAdded) {
                        this.chooseMe.BroadcastService.broadcast(
                            "add-new-team"
                        );
                    }
                }
            );
    };

    getCoverSheet: Function = () => {
        this.chooseMe.conditionalModuleLoadService.getCoverSheetService().then((service) => {
            service.openGenerateCoverSheetPopup(
                this.chooseMe.itemId,
                this.chooseMe.subject.teamMemberList.filter((user) => {
                    return !user.isFormerTeamMember;
                })
            );
        });
    };
    choices = [
        new EcvChoice(
            "addCR",
            "fa fa-user",
            this.addCR,
            "Manage Care Recipients"
        ),
        new EcvChoice("edit", "fa fa-pencil", this.editMe, "Edit Team"),
        new EcvChoice(
            "delete",
            "fa fa-trash",
            this.deleteMe,
            "delete team",
            "Are you sure you want to delete " +
            this.getSubjType(this.chooseMe.subject) +
            " Team? Click again to delete."
        ),
        new EcvChoice(
            "coverSheet",
            "fa fa-fax",
            this.getCoverSheet,
            "Get Cover Sheet"
        ),
    ];
}
class DashboardChoices extends EcvChooseMeChoiceList {
    constructor(chooseMe: IEcvChooseMe) {
        super(chooseMe);
    }
    getSubjType = (subject: Subject) => {
        let subjType = "the " + subject.projectName + " project";
        if (subject.subjectTypeId == "INDIVIDUAL") {
            subjType = subject.fullName + "'s";
        }
        return subjType;
    };
    editMe: Function = () => {
        if (
            !this.chooseMe.subject.isFrozen &&
            !!this.chooseMe.choiceBroadcast
        ) {
            this.chooseMe.choiceBroadcast("edit");
        }
    };
    addCR: Function = () => {
        this.chooseMe.pop
            .openAssociateTeamProjectPopup(this.chooseMe.subject)
            .then(
                (s) => {
                    this.chooseMe.subject.associatedSubjects = s.subjects;
                    this.chooseMe.updateSubjectCache(s.subjects);
                    this.chooseMe.BroadcastService.broadcast("add-new-team");
                },
                (e) => {
                    if (!!e && !!e.crAdded) {
                        this.chooseMe.BroadcastService.broadcast(
                            "add-new-team"
                        );
                    }
                }
            );
    };

    deleteMe: Function = () => {
        let subjType = this.getSubjType(this.chooseMe.subject);
        if (this.chooseMe.subject.subjectTypeId == "INDIVIDUAL") {
            subjType = this.chooseMe.subject.fullName + "'s";
        }
        let sent1 = Util.DELETE_TEAM.replace("$subject", subjType);
        this.chooseMe.flag = false;
        this.chooseMe.root.mainShowLoader = "Deleting ..";
        this.chooseMe.api.deleteSubject(this.chooseMe.itemId).then(
            () => {
                this.chooseMe.root.mainShowLoader = false;
                let removeTeam = (teams: Subject[]) => {
                    let indexOfSubject = teams.findIndex(
                        (sub) => sub.subjectId == this.chooseMe.itemId
                    );
                    teams.splice(indexOfSubject, 1);
                };
                removeTeam(this.chooseMe.CacheService.getSortedSubjects());
                removeTeam(this.chooseMe.CacheService.getSubjects());
                if (!!this.chooseMe.choiceBroadcast) {
                    this.chooseMe.choiceBroadcast("delete");
                }
                let infoMsg = "You have successfully deleted this Team.";
                toastr.success(infoMsg, "");
            },
            (e: any) => {
                this.chooseMe.pop.openInformationModal(e);
            }
        );
    };
    createUser: Function = () => {
        !!this.chooseMe.choiceBroadcast &&
            this.chooseMe.choiceBroadcast("createClientProfile");
    };
    resetPassword: Function = () => {
        !!this.chooseMe.choiceBroadcast &&
            this.chooseMe.choiceBroadcast("resetClientPassword");
    };
    choices = [
        new EcvChoice(
            "addCR",
            "fa fa-user",
            this.addCR,
            "Manage Care Recipients"
        ),
        new EcvChoice("edit", "fa fa-pencil", this.editMe, "Edit Team"),
        new EcvChoice(
            "delete",
            "fa fa-trash",
            this.deleteMe,
            "delete team",
            "Are you sure you want to delete " +
            this.getSubjType(this.chooseMe.subject) +
            " Team? Click again to delete."
        ),
        new EcvChoice(
            "createUser",
            "fa fa-user",
            this.createUser,
            "Create Client Account",
            "Are you sure you want to create client account? Click again to create."
        ),
        new EcvChoice(
            "resetPassword",
            "fa fa-rotate-right",
            this.resetPassword,
            "Reset Client Password",
            "Are you sure you want to reset client password? Click again to reset."
        ),
    ];
}
class ServiceChoices extends EcvChooseMeChoiceList {
    constructor(chooseMe: IEcvChooseMe) {
        super(chooseMe);
    }

    editMe: Function = () => {
        let options = this.chooseMe.item.serviceTemplateOptions.filter(
            (so) => so.optionId > 0 && !so.locked
        );
        // following code block requires as backend returns different models
        options = options.map((opt) => {
            return {
                serviceOptionId: opt.optionId,
                type: opt.optionType,
                value: opt.value,
                label: opt.optionLabel,
                editable: opt.editable,
            };
        });
        this.chooseMe.openEditServicePopup(this.chooseMe.item, options)
            .then((s) => {
                if (!!this.chooseMe.choiceBroadcast) {
                    this.chooseMe.choiceBroadcast(s);
                }
            });
    };

    deleteMe: Function = () => {
        let sent1 = Util.CLOSE_SERVICE.replace(
            "$service",
            this.chooseMe.item.serviceType
        );
        this.chooseMe.flag = false;
        this.chooseMe.root.mainShowLoader = "Closing ..";
        this.chooseMe.api
            .closeAssignedService(
                this.chooseMe.item.assignedServiceId,
                this.chooseMe.CacheService.getUser().password
            )
            .then((s) => {
                console.log(
                    this.chooseMe.itemType,
                    "with id",
                    this.chooseMe.itemId,
                    "has been deleted"
                );
                this.chooseMe.root.mainShowLoader = false;
                let infoMsg = Util.CLOSE_SERVICE_SUCCESS;
                toastr.success(infoMsg, "");
                this.chooseMe.$_state.go("parent.services.manage", {
                    page: "currentServices",
                });
            });
    };

    viewForm: Function = () => {
        let forms = this.chooseMe.item.forms;
        if (forms != "undefined" && forms.length > 0) {
            let assignedFormId = forms[0].assignedFormId;
            this.chooseMe.$_state.go("forms-load", {
                action: 'view',
                formId: 0,
                asgnId: assignedFormId,
                ref: "cmpf",
            });
        }
    };
    choices = [
        new EcvChoice(
            "edit",
            "fa fa-pencil",
            this.editMe,
            "Edit Assigned Service"
        ),
        new EcvChoice(
            "delete",
            "fa fa-times-circle-o",
            this.deleteMe,
            "Close Assigned Service",
            "Are you sure you want to close this service? Click again to close."
        ),
        new EcvChoice("viewForm", "fa fa-eye", this.viewForm, "View Form"),
    ];
}

class CombineChoices extends EcvChooseMeChoiceList {
    constructor(chooseMe: IEcvChooseMe) {
        super(chooseMe);
    }

    printMe: Function = () => {
        if (!!this.chooseMe.choiceBroadcast) {
            this.chooseMe.choiceBroadcast("combine-print");
        }
    };

    downloadMe: Function = () => {
        if (!!this.chooseMe.choiceBroadcast) {
            this.chooseMe.choiceBroadcast("combine-download");
        }
    };
    choices = [
        // new EcvChoice("print", "fa fa-print", this.printMe, "Combine + Print"),
        new EcvChoice(
            "download",
            "fa fa-download",
            this.downloadMe,
            "Combine + Download"
        ),
    ];
}

class ShareChoices extends EcvChooseMeChoiceList {
    constructor(chooseMe: IEcvChooseMe) {
        super(chooseMe);
    }

    showInfo: Function = () => {
        this.chooseMe.pop.openInformationModal(this.chooseMe.shareTooltip);
    };
    choices = [
        // new EcvChoice("help", "fa fa-question-circle ", this.howToshare, "How to share"),
        new EcvChoice(
            "privacy",
            "fa fa-user-secret",
            this.showInfo,
            "Privacy & Consent"
        ),
    ];
}

/* For Future Work

    class MemberChoices extends EcvChooseMeChoiceList {

    }
  */

export interface IEcvChooseMe {
    CacheService: CacheService;
    BroadcastService: BroadcastService;
    itemId: any;
    itemType: string;
    itemCategory: string;
    item: any;
    choiceList: EcvChooseMeChoiceList;
    choiceBroadcast: Function;
    api: JavaApiAdapterService;
    pop: PopUpService;
    feed: IFeedService;
    root: any;
    subject: Subject;
    shouldReload: boolean;
    sharingEnabled: boolean;
    signCopyExists: boolean;
    $_util: IUtilityService;
    uibModal: angular.ui.bootstrap.IModalService;
    $_state: angular.ui.IStateService;
    $_broadcast: BroadcastService;
    shareTooltip;
    flag: boolean;
    init(): void;
    killEvent($event: any): void;
    modifiable(): boolean;
    reload(): void;
    updateSubjectCache(subject: Subject[]): void;
    openEditServicePopup?: Function;
    conditionalModuleLoadService: IConditionalModuleLoadService;
}

class EcvChooseMe implements IEcvChooseMe {
    CacheService: CacheService;
    BroadcastService: BroadcastService;
    itemId: any;
    itemType: string;
    itemCategory: string;
    item: any;
    choiceList: EcvChooseMeChoiceList;
    choiceBroadcast: Function;
    api: JavaApiAdapterService;
    pop: PopUpService;
    feed: IFeedService;
    root: any;
    subject: Subject;
    shouldReload: boolean;
    $_util: IUtilityService;
    state: any;
    uibModal: angular.ui.bootstrap.IModalService;
    sharingEnabled: boolean;
    icon: string;
    $_state;
    $_document;
    signCopyExists: boolean;
    loading: boolean;
    $_broadcast;
    shareTooltip;
    flag: boolean;
    conditionalModuleLoadService: IConditionalModuleLoadService;

    static $inject = [
        "$rootScope",
        "ApiAdapterService",
        "PopUpService",
        "FeedService",
        "$state",
        "UtilityService",
        "$uibModal",
        "CacheService",
        "PushNotificationService",
        "SubjectService",
        "DocumentService",
        "BroadcastService",
        "TeamPermissionService",
        "PermissionService",
        "ConditionalModuleLoadService",
    ];
    constructor(
        private $rootScope: IAppRootScopeService,
        private $_api: JavaApiAdapterService,
        private $_pop: PopUpService,
        private $_feed: IFeedService,
        private $state: angular.ui.IStateService,
        $_util: IUtilityService,
        private $uibModal: angular.ui.bootstrap.IModalService,
        CacheService: CacheService,
        private PushNotificationService: PushNotificationService,
        private SubjectService: SubjectService,
        private $document: IDocumentService,
        BroadcastService: BroadcastService,
        private $_teamPerm: TeamPermissionService,
        private PermissionService: PermissionService,
        conditionalModuleLoadService: IConditionalModuleLoadService,
    ) {
        this.pop = $_pop;
        this.api = $_api;
        this.feed = $_feed;
        this.root = $rootScope;
        this.$_util = $_util;
        this.uibModal = $uibModal;
        this.$_state = $state;
        this.$_document = $document;
        this.$_broadcast = BroadcastService;
        this.CacheService = CacheService;
        this.conditionalModuleLoadService = conditionalModuleLoadService;
    }

    reload(): void {
        this.$state.reload();
    }

    init(): void {
        if (!this.itemType || !this.itemId) {
            console.error(
                "EcvChooseMe: Cannot open context menu for unknown type"
            );
            return;
        }
        this.flag = false;
        if (this.itemType != "SHARE") this.loading = true;

        switch (this.itemType) {
            case "SUBJECT":
                this.choiceList = new SubjectChoices(this);
                this.icon = "fa fa-cog";
                let subjType = "the " + this.subject.projectName + " project";
                if (this.subject.subjectTypeId == "INDIVIDUAL") {
                    subjType = this.subject.fullName + "'s";
                }
                break;
            case "DASHBOARDSUBJECT":
                this.choiceList = new DashboardChoices(this);
                this.icon = "fa fa-ellipsis-v context-menu-icon";
                break;
            case "SERVICE":
                this.choiceList = new ServiceChoices(this);
                this.icon = "fa fa-cog";
                break;
            case "SHARE":
                this.choiceList = new ShareChoices(this);
                this.icon = "fa fa-ellipsis-v";
                break;
            case "COMBINE":
                this.choiceList = new CombineChoices(this);
                this.icon = "fa fa-compress";
                break;
            default:
                console.error(
                    "EcvChooseMe: Item type of '",
                    this.itemType,
                    "not currently supported"
                );
                break;
        }

        if (this.itemType == "SUBJECT") {
            let amICaptain =
                this.subject.ownerId == this.CacheService.getUser().id;
            let actionToRemove: string[] = [];
            const choiceMenuOpetions = {
                delete: ["delete"],
                update: ["edit", "addCR"],
                // coverSheet:"coverSheet"("coverSheet" have to add permissions)
            };
            //Check for Delete Team action
            if (!amICaptain) {
                actionToRemove.push("delete");
            }

            //Check for Get Cover Sheet action
            if (
                !this.$_teamPerm.isModuleAllowedForTeam(
                    this.subject,
                    MODULES.COVERSHEET
                )
            ) {
                actionToRemove.push("coverSheet");
            }

            //Check for Edit Team action
            if (!amICaptain && !this.subject.coCaptain) {
                actionToRemove.push("edit");
            }

            //Check for Manage Care Recipients action
            if (this.subject.subjectTypeId != "PROJECT") {
                actionToRemove.push("addCR");
            } else {
                //For a project team if user is not captain or co-captain then remove manage CR option
                if (!amICaptain && !this.subject.coCaptain) {
                    actionToRemove.push("addCR");
                }
            }

            this.PermissionService.getPermissionsForTarget(TargetEnum.TEAM, [
                this.subject.teamPartyId,
            ]).then((permissions) => {
                if (Array.isArray(permissions) && permissions.length > 0) {
                    Object.keys(choiceMenuOpetions).forEach((key) => {
                        if (
                            permissions[0][TargetEnum.TEAM][key] &&
                            choiceMenuOpetions[key]
                        ) {
                            choiceMenuOpetions[key].forEach((value) => {
                                actionToRemove = actionToRemove.filter(
                                    (action) => {
                                        return value !== action;
                                    }
                                );
                            });
                        }
                    });
                }

                //Filter out the actions
                if (this.subject.subjectTypeId != "PROJECT") {
                    actionToRemove.push("addCR");
                }
                this.choiceList.choices = this.choiceList.choices.filter(
                    function (choice) {
                        return actionToRemove.indexOf(choice.action) < 0;
                    }
                );
                this.loading = false;
            });

            //Filter out the actions
            // this.choiceList.choices = this.choiceList.choices.filter(function (choice) {
            //     return actionToRemove.indexOf(choice.action) < 0;
            // });
        } else if (this.itemType == "DASHBOARDSUBJECT") {
            let actionToShow: string[] = [];
            let actionToRemove: string[] = [];
            const choiceMenuOpetions = {
                update: ["resetPassword"],
                create: ["createUser"],
                delete: ["delete"],
                updateTeam: ["edit", "addCR"],
            };

            this.PermissionService.getPermissionsForTarget(
                TargetEnum.DASHBOARD,
                [this.subject.teamPartyId]
            ).then((permissions) => {
                if (Array.isArray(permissions) && permissions.length > 0) {
                    Object.keys(choiceMenuOpetions).forEach((key) => {
                        if (
                            permissions[0][TargetEnum.DASHBOARD][key] &&
                            !!choiceMenuOpetions[key]
                        ) {
                            choiceMenuOpetions[key].forEach((value) => {
                                if (actionToShow.indexOf(value) < 0) {
                                    actionToShow.push(value);
                                }
                            });
                        }
                    });
                }

                if (
                    permissions[0][TargetEnum.DASHBOARD][
                    PermissionsEnum.UPDATE
                    ] ||
                    permissions[0][TargetEnum.DASHBOARD][PermissionsEnum.CREATE]
                ) {
                    !!this.subject.clientUsername
                        ? actionToShow.splice(
                            actionToShow.indexOf("createUser"),
                            1
                        )
                        : actionToShow.splice(
                            actionToShow.indexOf("resetPassword"),
                            1
                        );
                }

                if (this.subject.subjectTypeId != "PROJECT") {
                    actionToRemove.push("addCR");
                }

                this.choiceList.choices = this.choiceList.choices.filter(
                    function (choice) {
                        return actionToShow.includes(choice.action);
                    }
                );
                this.choiceList.choices = this.choiceList.choices.filter(
                    function (choice) {
                        return actionToRemove.indexOf(choice.action) < 0;
                    }
                );
                this.loading = false;
            });
        } else if (this.itemType == "SERVICE") {
            let actionToRemove: string[] = [];
            if (this.item.isServiceClosed) {
                actionToRemove.push("edit", "delete");
            } else if (
                !this.item.canEditService &&
                !this.item.isCurrentUserProvider &&
                !!this.item.userPerm
            ) {
                if (!this.item.userPerm["update"]) {
                    actionToRemove.push("edit");
                }
                if (!this.item.userPerm["delete"]) {
                    actionToRemove.push("delete");
                }
            }
            if (this.item.forms == "undefined" || this.item.forms.length == 0) {
                actionToRemove.push("viewForm");
            }
            this.choiceList.choices = this.choiceList.choices.filter(function (
                choice
            ) {
                return actionToRemove.indexOf(choice.action) < 0;
            });
            this.loading = false;
        } else if (
            this.itemType != "SERVICE" &&
            this.itemType != "SHARE" &&
            this.itemType != "COMBINE"
        ) {
            if (!this.sharingEnabled || this.sharingEnabled != true) {
                let shareChoice = this.choiceList.choices.filter(function (
                    choice
                ) {
                    return choice.action == "share";
                });
                this.choiceList.choices.splice(
                    this.choiceList.choices.indexOf(shareChoice[0]),
                    1
                );
            }
            this.loading = false;
        }

        if (_.includes(["COMBINE"], this.itemType)) {
            this.loading = false;
        }
    }

    killEvent($event: any): void {
        $event.stopPropagation();
    }

    modifiable = (): boolean => {
        return !this.subject || !this.subject.isFrozen;
    };

    updateSubjectCache(subjects: Subject[]): void {
        let input = {
            associatedSubjects: subjects,
        };
        this.SubjectService.updateSubject(this.subject.subjectId, input);
    }
}

function chooseMe(): ng.IDirective {
    return {
        restrict: "E",
        replace: true,
        template: `
                <div id="action-{{chooseMeVm.itemType}}-{{chooseMeVm.itemId.toString()}}" class="dropdown choose-me hide-print" uib-dropdown ng-if="!chooseMeVm.loading && chooseMeVm.choiceList.choices.length !== 0">
                  <button ng-if="chooseMeVm.modifiable()" class="btn btn-default  dropdown-toggle"
                  ng-click="chooseMeVm.killEvent($event)"
                  ng-disabled="chooseMeVm.itemDisabled"
                  ng-class="{'btn ecv-add-btn blue-button':chooseMeVm.itemType == 'COMBINE','disabled':!!chooseMeVm.itemDisabled,'settings-icon':chooseMeVm.itemType == 'SUBJECT'}"
                  uib-dropdown-toggle id="choose-me-{{chooseMeVm.itemType}}-{{chooseMeVm.itemId.toString()}}"
                  type="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i ng-if="chooseMeVm.itemType != 'SUBJECT' && chooseMeVm.itemType != 'COMBINE'" class="{{chooseMeVm.icon}}"></i>
                    <i ng-if="chooseMeVm.itemType == 'SUBJECT' " class="{{chooseMeVm.icon}}"
                    tooltip-placement="auto top" uib-tooltip="Options" tooltip-append-to-body="true"></i>
                    <span ng-if="chooseMeVm.itemType == 'COMBINE'" class="ecv-text-medium"><i class="{{chooseMeVm.icon}}"></i> COMBINE</span>
                  </button>
                  <ul class="uib-dropdown-menu dropdown-menu" role="menu">
                    <span class="spinner" ng-if="!!chooseMeVm.loading"><i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>
                    <li ng-repeat="choice in chooseMeVm.choiceList.choices" ng-if="!chooseMeVm.loading" role="menuitem" class="dropdown-item">

                        <a class="stop-click padding-internal"
                        ng-if="!choice.confirmation"
                          ng-click="choice.clickMe($event, chooseMeVm.itemCategory, chooseMeVm.itemId, chooseMeVm.signCopyExists)" daid="{{choice.text.replace('$ecvItemType', chooseMeVm.itemCategory) | titleCase}}" >
                            <i class="stop-click choose-me-choice-icon {{ choice.icon }}"
                            ng-if="choice.icon" ></i>
                            &nbsp;<span class="stop-click"
                            ng-bind="choice.text.replace('$ecvItemType', chooseMeVm.itemCategory) | titleCase"></span>
                        </a>

                        <a class="stop-click padding-internal-confirm" ng-if="!!choice.confirmation"
                          ecv-tooltip-msg ="choice.confirmation"
                          ecv-confirm-tooltip
                          ecv-outer-class = "'.body'"
                          ecv-flag="chooseMeVm.flag"
                          ecv-append-to-body = "'true'"
                          ecv-show-tooltip="true"
                          ecv-element-class = "'choose-menu-strech-me'"
                          ng-click="chooseMeVm.flag && choice.clickMe($event, chooseMeVm.itemCategory, chooseMeVm.itemId, chooseMeVm.signCopyExists)" daid="{{choice.text.replace('$ecvItemType', chooseMeVm.itemCategory) | titleCase}}" >
                          <i class="stop-click choose-me-choice-icon {{ choice.icon }}"
                            ng-if="choice.icon" ></i>
                            &nbsp;<span class="stop-click"
                            ng-bind="choice.text.replace('$ecvItemType', chooseMeVm.itemCategory) | titleCase"></span>
                        </a>
                    </li>
                  </ul>
                </div>
            `,
        controller: EcvChooseMe,
        controllerAs: "chooseMeVm",
        bindToController: {
            choiceBroadcast: "=?choiceBroadcast",
            itemId: " @itemId",
            itemType: "@itemType",
            item: "=?item",
            itemCategory: "@itemCategory",
            subject: "=?subject",
            shouldReload: "=ecvShouldReload",
            sharingEnabled: "=?ecvSharingEnabled",
            signCopyExists: "@signCopyExists",
            shareTooltip: "@?",
            itemDisabled: "=?itemDisabled",
            openEditServicePopup: "=?openEditServicePopup",
        },
        link: (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attributes: ng.IAttributes,
            controller: IEcvChooseMe
        ): void => {
            controller.init();
        },
    };
}

angular.module("eCareVault.common.menuOptions").directive("chooseMe", chooseMe);
